<template>
  <v-dialog v-model="dialog" width="800px" :fullscreen="$vuetify.breakpoint.smAndDown" @click:outside="cancel">
    <v-card>
      <v-card-title class="primary white--text"
        ><v-toolbar-title>LỊCH SỬ ĐỐI SOÁT</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-card-text>
        <ReportHistory v-if="show" />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-space-between pa-4">
        <v-btn class="px-6" color="primary" outlined light depressed @click="cancel">Đóng</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations } from 'vuex'
import ReportHistory from './ReportHistory.vue'
export default {
  components: {
    ReportHistory,
  },
  data() {
    return {
      dialog: false,
      show: false,
    }
  },
  methods: {
    ...mapMutations({
      setChecks: 'tuitionFeeCheck/setChecks',
    }),
    openDialog() {
      this.setChecks([])
      this.dialog = true
      this.show = true
    },
    cancel() {
      this.dialog = false
      this.show = false
    },
  },
}
</script>

<style></style>
